import styled from "styled-components";
import { WerfenColor, WerfenColorContrast, White } from "../../Constants/ColorChart";

export const StyledWrapper = styled.div`
    -webkit-app-region: drag;
	position: fixed;
    left: 0%;
    right: 0%;
    top: 0%;
    background: ${ WerfenColor };
    color: ${ White };
    height: 50px;
    z-index: 3;
    display: flex;
    transition: all 800ms ease-in-out;
    box-sizing: content-box;
    border-bottom: 6px solid ${ WerfenColorContrast };
    
    .LeftButtonDiv,
    .RightButtonDiv {
        flex-grow: 1;
        flex-shrink: 0;
        min-width: 50px;
        max-width: 145px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    
    .MainBarDiv {
        flex-grow:8
    }
    
    .top-bar-icon {
        width: 25px!important;
        @media (min-width: 992px){
            width: 40px!important;
            &.ProfileIcon {
                width: 33px!important;
                height: 33px!important;
            }
        }
    }
    
`;

export const Title = styled.div`
    display:flex;

    font-size: 20px;
    padding-top: ${ props => props.reducedFormat ? "8px" : "10px" };
    padding-bottom: 20px;
    transition: all 800ms ease-in-out;
    @media (max-width: 992px) {
        position: static;
        justify-content: center;
    }
    
`;
